// In-memory marker for the current auth session's persistence policy.
//
// Guest sessions are ephemeral: their tokens must never reach localStorage, so
// a page reload ends them — the flag-gated per-meeting guest credentials
// (`features.rememberGuests`) are their only durable trace. Module scope is
// intentional: it resets on reload, which is exactly the intended lifetime.
//
// Lifecycle: set by the guest login/resume flows right before `setTokens`;
// cleared when the session ends (`onTokens(undefined)` on logout), so a
// subsequent regular login persists normally.
let ephemeral = false;

export const markSessionEphemeral = () => { ephemeral = true; };
export const clearSessionEphemeral = () => { ephemeral = false; };
export const sessionIsEphemeral = () => ephemeral;
